import { HttpService } from "../http/HttpService";
import { AbstractAdminEntityService } from "./AbstractAdminEntityService";
import { CashbackSingleCurrencyPayoutListResponse, CashbackSingleCurrencyPayoutRow } from "../http/protocol";

export class CashbackSingleCurrencyPayoutService extends AbstractAdminEntityService<CashbackSingleCurrencyPayoutRow, CashbackSingleCurrencyPayoutListResponse> {
  constructor(http: HttpService) {
    super("/cashback/single-currency-payout", http);
  }
}
